import type { PostLoginPath } from "@crewledger/shared/beta-access";
import { POST_LOGIN_PATHS } from "@crewledger/shared/beta-access";

/** Maps session redirect targets for the marketing Get Started flow. */
export function resolveGetStartedDestination(redirectTo: PostLoginPath | null): string {
  if (!redirectTo || redirectTo === POST_LOGIN_PATHS.NOT_INVITED) {
    return POST_LOGIN_PATHS.REQUEST_ACCESS;
  }
  return redirectTo;
}
